export const variants = {
  none: `my-0`,
  md: `my-md`,
} as const;
